import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { CircularProgress, IconButton, InputAdornment, LinearProgress, Paper, Stack, TextField } from "@mui/material";

import { ActionSearchServiceFilter } from "./ActionSearchServiceFilter";
import { type ProviderFilter, type ServiceFilter } from "./hooks/useActionSearchDialogStateMachine";

type SearchHeaderProps = {
  query: string;
  setQuery: (query: string) => void;
  isLoading: boolean;
  provider?: ProviderFilter;
  service: ServiceFilter | undefined;
  onServiceChange: (service: ServiceFilter | undefined) => void;
};

export const SearchHeader = ({ query, setQuery, isLoading, onServiceChange, provider, service }: SearchHeaderProps) => (
  <Paper
    elevation={0}
    sx={{
      px: 3,
      pb: 2,
      position: "relative",
    }}
  >
    <Stack direction="row">
      <TextField
        variant="outlined"
        value={query}
        onChange={({ target: { value } }) => {
          setQuery(value);
        }}
        fullWidth
        autoFocus
        placeholder="Search actions"
        sx={{
          "& .MuiOutlinedInput-root": {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
        }}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {query && (
                  <IconButton
                    onClick={() => {
                      setQuery("");
                    }}
                    size="small"
                  >
                    <ClearIcon sx={{ width: 16, height: 16 }} />
                  </IconButton>
                )}
              </InputAdornment>
            ),
          },
        }}
      />
      {provider ? (
        <ActionSearchServiceFilter
          data-cy="action-search-service-filter"
          provider={provider}
          value={service}
          onChange={onServiceChange}
        />
      ) : (
        <Stack
          data-cy="action-search-service-filter-loading"
          sx={{
            alignItems: "center",
            justifyContent: "center",
            width: 300,
            height: 40,
            bgcolor: "background.paper",
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            border: 1,
            borderColor: "divider",
            borderLeft: "none",
          }}
        >
          <CircularProgress size={24} />
        </Stack>
      )}
    </Stack>
    {isLoading && <LinearProgress sx={{ position: "absolute", left: 0, bottom: 0, right: 0 }} />}
  </Paper>
);
